import React from "react";
import Button from "../button";
import { ButtonV2 } from "components/button-v2";

import { Box } from "@towersystems/towersystems-design-system";
import ButtonGroup from "../button-group";
import { MdDeleteOutline } from "react-icons/md";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { AiOutlinePlus } from "react-icons/ai";

function categorizeByDate(items) {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const categories = {
    today: [],
    yesterday: [],
    last30Days: [],
    earlier: [],
  };

  items
    .filter((i) => {
      return i.messageHistory?.length > 0;
    })
    .forEach((item) => {
      const createdAt = new Date(item.createdAt);
      const diffTime = today - createdAt;
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      if (createdAt.toDateString() === today.toDateString()) {
        categories.today.push(item);
      } else if (createdAt.toDateString() === yesterday.toDateString()) {
        categories.yesterday.push(item);
      } else if (diffDays <= 30) {
        categories.last30Days.push(item);
      } else {
        categories.earlier.push(item);
      }
    });

  return categories;
}

const ChatList = ({
  deleteChat = (id) => null,
  activeChatId,
  title = "Chat List",
  chats = [],
}) => {
  const [deletingChatId, setDeletingChatId] = React.useState(null);

  const handleOnDeleteChat = (id) => {
    setDeletingChatId(id);
    deleteChat(id)
      .then(() => {
        setDeletingChatId(null);
      })
      .catch(console.log);
  };

  return (
    <div className="mb-5">
      <div
        className=" font-semibold text-gray-500 mb-2 uppercase p-1 rounded-md chat-history-item-title"
        style={{
          fontSize: 14,
        }}
      >
        {title}
      </div>
      <ul>
        {chats.map((chat) => {
          // revrse the messages so that the last message is the lastUserMessage
          const lastUserMessage = chat.messageHistory
            .slice()
            .reverse()
            .find((message) => message.role === "user");

          const active = chat.id === activeChatId;
          return (
            <li
              key={chat.id}
              className={`chat-history-item rounded-md mb-2 p-1 ${active ? "bg-indigo-100" : ""}`}
            >
              <Button link={`/chat/${chat.id}`} fullWidth text>
                <div
                  className="flex items-center 
              "
                >
                  <div>
                    <IoChatboxEllipsesOutline
                      size={14}
                      className={`mr-2 font-normal ${
                        active
                          ? "font-semibold text-[#4394e5]"
                          : "font-normal text-gray-500"
                      }`}
                    />
                  </div>
                  <div
                    className={`
                      hover:underline decoration-indigo-600
                      ${
                        active
                          ? "font-semibold text-[#4394e5]"
                          : "font-normal text-gray-800"
                      } truncate text-ellipsis pr-3`}
                    style={{ fontSize: 13 }}
                  >
                    {lastUserMessage.message}
                  </div>
                </div>
              </Button>
              <div className="delete-chat">
                <Button
                  disabled={chat.id == deletingChatId}
                  onClick={() => handleOnDeleteChat(chat.id)}
                  icon
                >
                  <MdDeleteOutline size={20} />
                </Button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

function ChatHistory({
  deleteChat,
  activeChatId = null,
  chats = [],
  isLoading = false,
  clearState = () => null,
}) {
  if (isLoading && chats.length === 0) {
    return <div></div>;
  }

  const categorizedChats = categorizeByDate(chats); // { today: [], yesterday: [], last30Days: [], earlier: [] }

  const todayMarkup = categorizedChats.today.length ? (
    <ChatList
      deleteChat={deleteChat}
      title="Today"
      chats={categorizedChats.today}
      activeChatId={activeChatId}
    />
  ) : null;

  const yesterdayMarkup = categorizedChats.yesterday.length ? (
    <ChatList
      deleteChat={deleteChat}
      title="Yesterday"
      chats={categorizedChats.yesterday}
      activeChatId={activeChatId}
    />
  ) : null;

  const last30DaysMarkup = categorizedChats.last30Days.length ? (
    <ChatList
      deleteChat={deleteChat}
      title="Last 30 days"
      chats={categorizedChats.last30Days}
      activeChatId={activeChatId}
    />
  ) : null;

  const earlierMarkup = categorizedChats.earlier.length ? (
    <ChatList
      deleteChat={deleteChat}
      title="Earlier"
      chats={categorizedChats.earlier}
      activeChatId={activeChatId}
    />
  ) : null;

  const newConversationMarkup = (
    <Box className="mb-4">
      <ButtonGroup>
        <ButtonV2
          leftIcon={<AiOutlinePlus size={20} />}
          variant="primary"
          onClick={clearState}
          fullWidth
          elevation={1}
        >
          New Conversation
        </ButtonV2>
      </ButtonGroup>
    </Box>
  );

  return (
    <div>
      {newConversationMarkup}
      {todayMarkup}
      {yesterdayMarkup}
      {last30DaysMarkup}
      {earlierMarkup}
    </div>
  );
}

export default ChatHistory;
